<template>
  <div>{{ $t('common.redirecting') }}</div>
</template>

<script>
import { trackingAdv } from '@/utils'
import { ENV_KEY } from '@/constants/env'
import liff from '@line/liff'
import { AuthService, LineLinkService } from '@/services'
import { AD_USER_ID, ADCD, SAVE_ACCOUNT_STATUS_ERROR } from '@/constants'

export default {
  computed: {
    redirectAddLineUrl() {
      return `https://line.me/R/ti/p/~${this.$store.getters['env/GET_KEY'](ENV_KEY.LINE_BOT_ID)}`
    },
  },
  async created() {
    const redirect_url = this.$route.query.redirect_url
    const code = this.$route.query.code
    const state = this.$route.query.state
    const customer_id = this.$route.query.customer_id || undefined
    const ad_user_id = this.$route.query.ad_user_id || localStorage.getItem(AD_USER_ID)
    const adcd = this.$route.query.adcd || localStorage.getItem(ADCD)
    const error = this.$route.query.error

    let redirect_uri = `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${
      this.$routePage.CALLBACK
    }?redirect_url=${this.redirectAddLineUrl}&customer_id=${customer_id}${
      adcd && ad_user_id ? `&adcd=${adcd}&ad_user_id=${ad_user_id}` : ''
    }`

    if (this.$route.query.action === this.Constants.ACTION_LINE.LOGIN_LINE) {
      if (this.liffIdExists) {
        if (liff.isLoggedIn()) {
          const { data } = await AuthService.login({
            accessToken: liff.getAccessToken(),
          })
          if (data.customer && adcd && ad_user_id) {
            trackingAdv(adcd, ad_user_id, redirect_uri).catch(() => {
              localStorage.removeItem(this.Constants.ADCD)
            })
          }

          if (!data.customer) {
            this.handleError({ message: this.$t('common.messages.lineNotHasCustomers') })
            liff && liff.logout()
          }

          this.$router.replace({ path: redirect_url })
        } else {
          this.Utils.trackingPermission()
          this.$router.replace({ path: this.$routePage.EC_LINE001 })
        }
      } else {
        this.$router.replace({ path: this.$routePage.EC_LINE001 })
      }
    } else {
      if (code && state) {
        if (adcd && ad_user_id) {
          trackingAdv(adcd, ad_user_id, redirect_uri, code, state, customer_id)
            .then(({ friend_status_id }) => {
              if (
                friend_status_id === this.Constants.FRIEND_STATUS.ADD ||
                friend_status_id === this.Constants.FRIEND_STATUS.ADDED
              ) {
                window.location.href = redirect_url
              } else {
                this.$router.replace({ path: this.$routePage.EC_LINE001 })
              }
            })
            .catch(async (error) => {
              const statusError = error.response?.data.meta.app_status

              if (statusError === SAVE_ACCOUNT_STATUS_ERROR.ADCD_INCORRECT) {
                localStorage.removeItem(this.Constants.ADCD)
                await this.saveLinkAccount(code, state, redirect_url, customer_id)
              } else {
                this.handleError(error)
                this.$router.replace({ path: this.$routePage.EC_LINE001 })
              }
            })
        } else {
          await this.saveLinkAccount(code, state, redirect_url, customer_id)
        }
      } else if (!code && error) {
        this.Utils.trackingPermission()
        this.$router.replace({ path: this.$routePage.EC_LINE001 })
      } else {
        this.handleLineLogin()
      }
    }
  },
  methods: {
    async saveLinkAccount(code, state, redirect_url, customer_id) {
      try {
        await LineLinkService.linkAccount({
          code,
          state,
          redirect_uri: `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${
            this.$routePage.CALLBACK
          }?redirect_url=https://line.me/R/ti/p/~${this.$store.getters['env/GET_KEY'](
            ENV_KEY.LINE_BOT_ID
          )}&customer_id=${customer_id}`,
          customer_id,
        })

        window.location.href = redirect_url
      } catch (error) {
        const statusError = error.response?.data.meta.app_status
        if (statusError === SAVE_ACCOUNT_STATUS_ERROR.INVALID) {
          this.handleError(error)
        }

        this.$router.replace({ path: this.$routePage.EC_LINE001 })
      }
    },

    async handleLineLogin() {
      if (!liff.isLoggedIn()) {
        this.$router.replace({ path: this.$routePage.EC_LINE001 })
        return
      }

      const { data } = await AuthService.login({
        accessToken: liff.getAccessToken(),
      })
      const userStatus = this.$route.query.user_status

      if (userStatus === this.Constants.USER_STATUS.NOT_LOGGED && data.customer) {
        await this.trackingAddFriend()
        this.$router.replace({ path: this.$route.query.redirect_url })
        return
      } else if (this.user?.line_id && data.line_id !== this.user.line_id && data.customer) {
        this.handleError({ message: this.$t('common.messages.lineHasDifferentCustomer') })
        liff && liff.logout()
        this.$router.replace({ path: this.$route.query.redirect_url })
        return
      } else if (this.user?.line_id && !data.customer) {
        this.handleError({ message: this.$t('common.messages.lineHasDifferentCustomer') })
        liff && liff.logout()
        this.$router.replace({ path: this.$route.query.redirect_url })
        return
      }

      this.checkFriendShip(this.$route.query.redirect_url)
    },

    async checkFriendShip(redirect_url) {
      try {
        const notAddStatus = [this.Constants.FRIEND_STATUS.PERMISSION, this.Constants.FRIEND_STATUS.NOT_ADD]
        let friendStatus = await this.trackingAddFriend()

        if (notAddStatus.includes(friendStatus)) {
          window.location.href = this.redirectAddLineUrl
          return
        } else {
          this.$router.replace({ path: `${redirect_url}/confirm` })
        }
      } catch (error) {
        window.location.href = this.redirectAddLineUrl
      }
    },

    async trackingAddFriend() {
      const ad_user_id = localStorage.getItem(AD_USER_ID)
      const adcd = localStorage.getItem(ADCD)
      const userId = this.user?.line_id || (liff.isLoggedIn() && (await liff.getProfile()).userId)
      let redirect_uri = `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${
        this.$route.path === this.$routePage.EC_LINE029_001
          ? this.$routePage.EC_LINE029_001
          : this.$routePage.EC_LINE029_002
      }`

      return LineLinkService.checkFriendLine(userId).then(async ({ data }) => {
        if (adcd && ad_user_id) {
          await trackingAdv(adcd, ad_user_id, redirect_uri).catch(() => {
            localStorage.removeItem(this.Constants.ADCD)
          })
        }

        return data.friend_status_id
      })
    },
  },
  metaInfo() {
    return {
      title: this.$t('common.redirecting'),
    }
  },
}
</script>
